import * as request from "@/utils/request";
import { DefaultConfigs } from "@/common/js/constant";
import { SafePerceptionInfo } from "./types";

const baseUrl = `${DefaultConfigs.publicAPIPath}`;

// 获取安全感知信息
export function getSafePerceptionInfo() {
  return request.get<SafePerceptionInfo>(`${baseUrl}/sofipo/v0/user/safePerception`, {});
}
